
export default {
    props: {
        type: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: ''
        }
    },
    functional: true,
    render(h: any, ctx: any) {
        const { type, text, color } = ctx.props
        return (
            <div class={type} i-class="flex align-middle">
                <span class={['dot', `${type}-dot`]} i-class="inline-block round mr-4"
                    style={{ backgroundColor: color }}>
                </span>
                { text }
            </div>
        )
    }
}
